export default "__VITE_ASSET__BNbQMuZr__"